import { render, staticRenderFns } from "./ProductDetailSettings.vue?vue&type=template&id=67b2793c"
import script from "./ProductDetailSettings.vue?vue&type=script&lang=js"
export * from "./ProductDetailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports